import { useCallback, useMemo } from 'react';

import { UserPreferenceApiConnector } from '@/modules/api/UserPreferenceApiConnector/UserPreferenceApiConnector';
import { patchUserPreferencesWithOutdatedTypes } from '../helpers';
import { useUserPreferencesStore } from '../store';

export const useLoadUserPreferences = () => {
  const api = useMemo(() => UserPreferenceApiConnector.getInstance(), []);

  const load = useCallback(async (): Promise<boolean> => {
    const storedUserPreferences = await api.fetchAll();

    if (!storedUserPreferences) return false;

    const userPreferences = patchUserPreferencesWithOutdatedTypes(storedUserPreferences);

    useUserPreferencesStore.getState().initialize(userPreferences);

    return true;
  }, [api]);

  return {
    load,
  };
};
